import angular from 'angular';
import SerieSelectorCtrl from './serieSelector.controller';
import serieSelectorDirective from './serieSelector.directive';

export default angular.module('serieSelector', [])
    .directive('serieSelector', serieSelectorDirective)
    .controller('SerieSelectorCtrl', SerieSelectorCtrl)
    .name;